import { PostProvider } from './SocialNetworks/contexts/PostContext';
import { Switch } from 'react-router-dom';
import Activities from './Activities';
import Agenda from './Agenda';
import BankParameters from './Parameters/BankParameters';
import Bills from './Parameters/Bills';
import Clients from './Clients';
import CompaniesParameters from './Parameters/CompaniesParameters';
import Dashboard from './Dashboard';
import EmployeesParameters from './Parameters/EmployeesParameters';
import Help from './Help';
import Invite from './Parameters/Invite';
import LocationParameters from './Parameters/AddressesParameters';
import Messaging from './Messaging';
import NoteDescriptif from './Parameters/NoteDescriptif';
import Notification from './Parameters/Notification';
import Parameters from './Parameters';
import PrivateRoute from 'routes/PrivateRoute';
import routes from 'config/routes';
import SecurityParameters from './Parameters/SecurityParameters';
import SocialNetworks from './SocialNetworks';
import SocialNetworksParameters from './Parameters/SocialNetworksParameters';

function MainArea() {
  return (
    <Switch>
      <PrivateRoute path={routes.activities.root} hasLayout>
        <Activities />
      </PrivateRoute>
      <PrivateRoute path={routes.agenda.root} hasLayout>
        <Agenda />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.bank.root} hasLayout>
        <BankParameters />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.bills.root} hasLayout>
        <Bills />
      </PrivateRoute>
      <PrivateRoute path={routes.clients.root} hasLayout>
        <Clients />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.companies.root} hasLayout>
        <CompaniesParameters />
      </PrivateRoute>
      <PrivateRoute exact path={routes.home.root} hasLayout>
        <Dashboard />
      </PrivateRoute>
      <PrivateRoute path={routes.help.root} hasLayout>
        <Help />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.invite.root} hasLayout>
        <Invite />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.location.root} hasLayout>
        <LocationParameters />
      </PrivateRoute>
      <PrivateRoute path={routes.messaging.root} hasLayout>
        <Messaging />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.noteDescription.root} hasLayout>
        <NoteDescriptif />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.notifications.root} hasLayout>
        <Notification />
      </PrivateRoute>
      <PrivateRoute exact path={routes.parameters.root} hasLayout>
        <Parameters />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.security.root} hasLayout>
        <SecurityParameters />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.team.root} hasLayout>
        <EmployeesParameters />
      </PrivateRoute>
      <PrivateRoute path={routes.parameters.socialNetworks.root} hasLayout>
        <SocialNetworksParameters />
      </PrivateRoute>
      <PrivateRoute path={routes.socialNetworks.root} hasLayout>
        <PostProvider>
          <SocialNetworks />
        </PostProvider>
      </PrivateRoute>
    </Switch>
  )
}

export default MainArea;
